import showError from './error-box';

$('.btn.count').on('click', function () {
  const text = $('textarea').val().trim();
  if (text === '') return;
  $('.btn.count .icon.spinner').show();
  $.ajax({
    method: 'POST',
    url: `${baseUrl}/count`,
    data: JSON.stringify({ text }),
    processData: false,
    contentType: 'application/json;charset=UTF-8',
    dataType: 'json',
    complete() {
      $('.btn.count .icon.spinner').hide();
    },
    success(data) {
      $('.btn.count .icon.ok').show();
      setTimeout(() => {
        $('.btn.count .icon.ok').hide();
      }, 1000);

      $('.words').text(data.wordCount);
      $('.characters').text(data.characterCount);
      $('.sentences').text(data.sentenceCount);
      $('.paragraphs').text(data.paragraphCount);
      $('.read-time').text(
        data.readTime.minutes
          ? `${data.readTime.minutes} min`
          : `${data.readTime.seconds} sec`
      );
      $('table.single-word tbody').empty();
      $('table.double-words tbody').empty();
      $('table.triple-words tbody').empty();
      data.density.singles.forEach(single =>
        $('table.single-word tbody').append(tableRowTemplate(single))
      );
      data.density.doubles.forEach(double =>
        $('table.double-words tbody').append(tableRowTemplate(double))
      );
      data.density.triples.forEach(triple =>
        $('table.triple-words tbody').append(tableRowTemplate(triple))
      );
      $('.result').fadeIn(0.3);
      $('.result')
        .get(0)
        .scrollIntoView({ behavior: 'smooth', block: 'start' });
    },
    error(xhr, _, error) {
      $('.btn.count .icon.error').show();
      setTimeout(() => {
        $('.btn.count .icon.error').hide();
      }, 1000);
      // https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest/readyState
      switch (xhr.readyState) {
        case 0:
          // network error
          showError(locales.networkError);
          break;

        case 4:
          // HTTP error
          showError(error);
          break;
        default:
          // something weird happened
          break;
      }
    }
  });
});

const tableRowTemplate = ({ word, value }) => `<tr>
<td class="word w-100">${word}</td>
<td class="text-end px-4"><span class="badge density bg-secondary p-2">${value}</span></td>
</tr>`;
